import type { BackendFlagLogItem } from './moderation.api-types'
import { type ModerationMessage, type MessageType, ModerationActionType } from '../domain/models/moderation.model'

export function mapResolutionToActions(resolution: string | null): ModerationActionType[] {
  switch (resolution) {
    case 'content_deleted':
    case 'auto_deleted':
      return [ModerationActionType.Deleted]
    case 'user_banned':
      return [ModerationActionType.Ban]
    case 'approved':
    case null:
    default:
      return []
  }
}

export function mapFlagLogToMessage(log: BackendFlagLogItem, ruleName: string): ModerationMessage {
  // Use `!= null` (instead of `!== null`) so both `null` and `undefined`
  // are treated as "not a chat message". The backend always sends `null`,
  // but defensive equality avoids subtle bugs if the field is ever omitted.
  const isChatMessage = log.stream_message_id != null
  const isComment = log.forum_comment_id != null
  const type: MessageType = isChatMessage ? 'chat_message' : isComment ? 'post_comment' : 'post'
  const body = isChatMessage
    ? log.stream_message_text ?? ''
    : isComment
    ? log.forum_comment_text ?? ''
    : log.forum_post_content ?? ''

  const title = isChatMessage ? `Chat message flagged: "${log.matched_pattern}"` : log.forum_post_title ?? ''

  return {
    id: String(log.id),
    date: new Date(log.created_at),
    type,
    title,
    body,
    authorName: log.display_name || log.username || 'Deleted user',
    authorAvatarUrl: log.avatar_url ?? '',
    actions: mapResolutionToActions(log.resolution),
    isReviewed: !log.needs_action,
    autoModerated: log.resolution === 'auto_deleted',
    flaggedByKeyword: ruleName
  }
}
